module.exports = __webpack_public_path__ + "static/media/Notice.07ff6137.jpg";